module.exports = __webpack_public_path__ + "static/media/logowhitewithbadge.64adf62b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logowhitewithbadge.svg
// module id = 775
// module chunks = 0